export default {
    homepage: '50uuWLyVbdQfZKpgWauh0N',
    storeLocator: '7LBHyayGxRXMiF1Z2uz1LY',
    meetOurStylist: '4WTLgx9hhjxT3JxodmAqFy',
    butterCup: '2MbHxidNzXKTBbMZjMDQdc',
    barflyMembership: '3Aw4uPJ7h8eRHBavDxoh0t',
    buyout: 'w1NcqRAZLNaUh4OI5fORl',
};
